import { configureStore, combineReducers } from '@reduxjs/toolkit';
import alertReducer from 'reducers/alertReducer';
import authCompanyReducer from 'reducers/authCompanyReducer';
import campaignNotificationReducer from 'reducers/campaignNotificationReducer';
import latestSystemNotificationReducer from 'reducers/latestSystemNotificationReducer';
import loadingReducer from 'reducers/loadingReducer';
import notFoundReducer from 'reducers/notFoundReducer';
import { authCompanyApi } from 'services/authCompany'
import { branchApi } from 'services/company/branch';
import { companyUserApi } from 'services/company/company_user';
import { infoApi } from 'services/company/info';
import { notificationApi } from 'services/company/notification';
import { systemSettingApi } from 'services/company/systemSetting';
import { trainingsApi } from 'services/company/training';
import { usersApi } from 'services/company/user';

const rootReducer = combineReducers({
  authCompany: authCompanyReducer,
  campaignNotification: campaignNotificationReducer,
  latestSystemNotification: latestSystemNotificationReducer,
  alert: alertReducer,
  loading: loadingReducer,
  notFound: notFoundReducer,
  [authCompanyApi.reducerPath]: authCompanyApi.reducer,
  [branchApi.reducerPath]: branchApi.reducer,
  [companyUserApi.reducerPath]: companyUserApi.reducer,
  [infoApi.reducerPath]: infoApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [systemSettingApi.reducerPath]: systemSettingApi.reducer,
  [trainingsApi.reducerPath]: trainingsApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authCompanyApi.middleware,
      branchApi.middleware,
      companyUserApi.middleware,
      infoApi.middleware,
      systemSettingApi.middleware,
      trainingsApi.middleware,
      usersApi.middleware,
    )
})
